module.exports = __webpack_public_path__ + "static/media/bassoon.a39f230a.wav";